import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

/**
 * Custom hook to handle order locked popup and order summary modal state.
 * @param {Object} params
 * @param {Object} params.orderLockedDataValue - The order locked data value object.
 * @param {Object} params.usageOrderSubmission - The usage order submission object.
 * @param {Function} params.setShowOrderLockedPopup - Setter for order locked popup state.
 * @param {Function} params.dispatch - Redux dispatch function.
 * @param {Function} params.setOrderSummaryModalState - Redux action creator for order summary modal state.
 * @param {Object} params.history - React Router history object.
 */
export function useOrderLockedEffect({
    orderLockedDataValue,
    usageOrderSubmission,
    setShowOrderLockedPopup,
    dispatch,
    setOrderSummaryModalState,
    history,
}) {
    useEffectWithErrorLogging(() => {
        if (orderLockedDataValue?.isOrderLocked) {
            !(
                usageOrderSubmission &&
                (usageOrderSubmission?.statusCode ||
                    usageOrderSubmission?.errorCode) &&
                usageOrderSubmission?.clickedBtn === 'submit'
            )
                ? setShowOrderLockedPopup({
                      show: true,
                      myCaseRef: history.location.pathname.replace(
                          '/reportUsage/',
                          ''
                      ),
                      modifiedBy: orderLockedDataValue?.user,
                  })
                : dispatch(
                      setOrderSummaryModalState({
                          myCaseRef: history.location.pathname.replace(
                              '/reportUsage/',
                              ''
                          ),
                          orderSummaryModal: false,
                      })
                  );
        } else {
            dispatch(
                setOrderSummaryModalState({
                    myCaseRef: history.location.pathname.replace(
                        '/reportUsage/',
                        ''
                    ),
                    orderSummaryModal: false,
                })
            );
        }
    }, [orderLockedDataValue]);
}
